import { render } from "./ClinicalResearchComponent.vue?vue&type=template&id=5a6121a8&scoped=true"
import script from "./ClinicalResearchComponent.vue?vue&type=script&lang=js"
export * from "./ClinicalResearchComponent.vue?vue&type=script&lang=js"

import "./ClinicalResearchComponent.vue?vue&type=style&index=0&id=5a6121a8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6121a8"]])

export default __exports__